var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"Community-view",attrs:{"column":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n      Communities Page\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }